import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';
import { Popconfirm, Tooltip, Tag, Input,Button } from 'antd';
import { API_MASTERJOBPLAN } from '../../../../../commons/api';

import { getJobPlansList, deleteById } from '../../../Utils/FormCalls';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';

const JobPlanList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const navigate = useNavigate();

  let config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['JobPlanName', 'JobPlanDescription'],
    firstTitle: 'JobPlanName',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/JobPlanDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    _getDataSource();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  // const _getUserList = async () => {
  //   let userList = await getUsersList();
  //   setUserList(userList);
  // };

  const _getDataSource = async () => {
    let dataSource = await getJobPlansList('both');
    setDataSource(dataSource);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <SearchOutlined
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 90, marginRight: 8, }}
        />
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const editJobPlan = async (record) => {


    // Ensure base64_encode is defined

    const encodedId = base64_encode(record.Id);
    navigate(`${config && config.edit && config.edit.redirectURL}/${encodedId}`);

  };

  const _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      url: `${API_MASTERJOBPLAN.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    let dataSource = await getJobPlansList('both');
    setDataSource(dataSource);
  };

  const { translationCache } = props;
  const columns = [
    {
      title: translation(translationCache, constant.jobPlan),
      dataIndex: 'JobPlanName',
      key: 'JobPlanName',
      filter: true,
      ...getColumnSearchProps('JobPlanName')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'JobPlanDescription',
      key: 'JobPlanDescription',
      ...getColumnSearchProps('JobPlanDescription')
    },
    {
      title: translation(translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName',
      filter: true
    },
    {
      title: translation(translationCache, constant.status),
      dataIndex: 'JobPlanStatusId',
      key: 'JobPlanStatusId',
      render: (text) => (
        <Tag
          color={
            text && text === 'Active' ? '#87d068' : text === 'Inactive' ? '#ff4d4f' : 'gold'
          }
          key={text}
        >
          {text && text === 4 ?
            translation(translationCache, 'Disable') : translation(translationCache, 'Enable')}
        </Tag>
      )
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Tooltip title={translation(translationCache, 'Edit')}>
            <Button
              disabled={record.Status === 'Inactive'}
              style={{ marginRight: '5px' }}
              onClick={() => editJobPlan(record)}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title={translation(translationCache, constant.deleteJobPlan)}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(translationCache, constant.yes)}
            cancelText={translation(translationCache, constant.no)}
          >
            <Tooltip title={translation(translationCache, 'Delete')}>
              <Button>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      )
    }
  ];
  config = {
    title: translation(translationCache, 'JobPlans'),

    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',

    filterType: 'ByAttributeValue',
    attributeList: ['JobPlanName'],

    firstTitle: 'JobPlanName',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',

    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/JobPlanDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        // userList={userList}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile
  };
};

export default connect(mapStateToProps)(JobPlanList);